// @flow

import _ from 'lodash/fp';
import React from 'react';
import {Field} from 'redux-form';
import BasicFormInput from '../BasicFormInput/BasicFormInput';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import ActionConfirmation from '../../containers/ActionConfirmation/ActionConfirmation';
import DisableContent from '../DisableContent/DisableContent';
import './RoomForm.css';
import type {
  LimitedProjectDto,
  RoomDto,
  RoomTemplateDto,
  RoomTypeDto,
} from '../../dtos';

const notArchived =
  _.filter({archived: null});

const includeRoom = room =>
  _.filter(t => t.id === room.roomTypeId || !t.archived);

const filterRooms = room =>
  room
    ? includeRoom(room)
    : notArchived;

export type Props = {
  room: ?RoomDto,
  roomTypes: RoomTypeDto[],
  onUserChange: () => any,
  onArchive: () => any,
  isDirty: boolean,
  updateRooms: (sortDirection: 'up' | 'down') => void,
  sortDownDisabled: boolean,
  sortUpDisabled: boolean,
  projects: LimitedProjectDto[],
  roomTemplates: RoomTemplateDto[],
  formValues: any,
};

const RoomForm = ({
  room,
  onArchive,
  roomTypes,
  onUserChange,
  isDirty,
  updateRooms,
  sortDownDisabled,
  sortUpDisabled,
  projects,
  roomTemplates,
  formValues,
}: Props) => (
  <div className="RoomForm">
    <div className="row align-justify align-middle box-header">
      <div className="column">
        <span className="box-title">
          {(room && room.name) || 'Nytt rum'}
        </span>
      </div>
      <div className="column shrink horizontal-button-list">
        {room && room.id && (
          <DisableContent disabled={isDirty}>
            {[
              <button
                key={0}
                type="button"
                className="button secondary small"
                disabled={sortUpDisabled}
                onClick={() => updateRooms('up')}>
                <i className="fa fa-arrow-up"/>
              </button>,
              <button
                key={1}
                type="button"
                className="button secondary small"
                disabled={sortDownDisabled}
                onClick={() => updateRooms('down')}>
                <i className="fa fa-arrow-down"/>
              </button>,
              <ActionConfirmation
                key={2}
                id="archiveRoom"
                className="secondary small"
                message={`Vill du verkligen ${room.archived ? 'av' : ''}arkivera det här rummet?`}
                buttonText={room.archived ? 'Avarkivera' : 'Arkivera'}
                action={onArchive} />,
            ]}
          </DisableContent>
        )}
      </div>
    </div>
    <Field
      name="name"
      label="Namn"
      onChange={onUserChange}
      component={BasicFormInput}
      type="text" />
    {room && room.id && (
      <Field
        name="roomTypeId"
        label="Rumstyp"
        normalize={value => value ? value.id : null}
        onChange={onUserChange}
        component={SelectFormInput}
        valueKey="id"
        labelKey="name"
        options={filterRooms(room)(roomTypes)} />
    )}
    {(!room || !room.id) && (
      <div onChange={onUserChange}>
        <label>
          Produktplatser
        </label>
        <label>
          <Field
            name="slots"
            component="input"
            type="radio"
            value="NONE" /> Lägg till manuellt
        </label>
        <Field
          name="roomTypeId"
          label="Rumstyp"
          normalize={value => value ? value.id : null}
          disabled={!formValues || formValues.slots !== 'NONE'}
          onChange={onUserChange}
          component={SelectFormInput}
          valueKey="id"
          labelKey="name"
          options={roomTypes} />
        <label>
          <Field
            name="slots"
            component="input"
            type="radio"
            value="ROOM" /> Kopiera från rum
        </label>
        <Field
          name="project"
          component={SelectFormInput}
          normalize={value => value ? value : null}
          disabled={!formValues || formValues.slots !== 'ROOM'}
          placeholder="Välj projekt"
          valueKey="id"
          labelKey="name"
          options={projects} />
        <Field
          name="config"
          component={SelectFormInput}
          normalize={value => value ? value : null}
          disabled={!formValues || formValues.slots !== 'ROOM' || !formValues.project}
          placeholder="Välj konfiguration"
          valueKey="id"
          labelKey="name"
          options={!!formValues && !!formValues.project ? formValues.project.apartmentConfigs : []} />
        <Field
          name="basedOnRoomId"
          component={SelectFormInput}
          normalize={value => value ? value.id : null}
          disabled={!formValues || formValues.slots !== 'ROOM' || !formValues.project || !formValues.config}
          placeholder="Välj rum"
          valueKey="id"
          labelKey="name"
          options={!!formValues && !!formValues.config ? formValues.config.rooms : []} />
        <label>
          <Field
            name="slots"
            component="input"
            type="radio"
            value="TEMPLATE" /> Basera på mall
        </label>
        <Field
          name="basedOnTemplateId"
          component={SelectFormInput}
          normalize={value => value ? value.id : null}
          disabled={!formValues || formValues.slots !== 'TEMPLATE'}
          placeholder="Välj mall"
          valueKey="id"
          labelKey="name"
          options={roomTemplates} />
      </div>
    )}
  </div>
);

export default RoomForm;



// WEBPACK FOOTER //
// ./src/components/RoomForm/RoomForm.js